define([
	"dojo/_base/declare",
	"csi/heading/Enum",
	"csi/locale",
	"Apparel/ProductType"
], function(declare, Enum, locale, ProductType) {

	return declare(Enum, {
		validateValue: function(/*Context*/ctx, /*Heading*/h, /*Any*/value) {
			// see if it's being changed to Style.  if so, make sure there isn't an ApplicableBOMProductType with inAssortment = false
			var node = ctx.getNode();
			if (value == "ProductType:Style") {
				if (node.BOMProductType != "ProductType:Style") {
					throw new Error(locale.resource("BomSectionProductType_Error"));
				} else {
					// if there is a BOM Product Type with IsAssortment = false throw error if Placement Product Type is Style
					node.BOMProductTypes.forEach(function(BOMPT) {
						if (!ProductType.getByUrl(BOMPT, "IsAssortment")) {
							throw new Error(locale.resource("BomSectionIsAssortment_Error", [ProductType.getTypeName(BOMPT)]));
						}
					});
				}
			}
		},
	});
});
